// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"QF-rJYs0VnPa3z-IJ0Dxc","title":"_155WKBCo3IEv1TpMhM4WuH","triangleRight":"_3OcvaqqiIHYhM940_UEaya","triangleDown":"Gwgp0DtCM9f0xIuw7yN5w","closed":"KMsAbLJ4AzrjpVJFi9gbD"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/baseball/css/accordion.css
// module id = 970
// module chunks = 0